import clsx from 'clsx';
import React from 'react';
import { StatusColor } from 'types/Status';
import { Badge } from 'antd';

export default function Tag({
  status,
  color,
  full = false,
  className,
}: {
  status?: string;
  color: StatusColor;
  full?: boolean;
  className?: string;
}) {
  return status ? (
    <Badge
      className={clsx(full ? 'w-full' : '', className)}
      count={
        <span
          className={clsx(
            'py-2 px-5 rounded-[4px] -my-2 text-center text-white',
            full ? 'block w-full' : 'inline-block',
          )}
          style={{
            backgroundColor: color.bg,
            color: color.text,
          }}
        >
          {status}
        </span>
      }
    />
  ) : null;
}
